<template>
  <div class="home-page">
    <adver @received="received" :isShow="pop" :isnew="isnew" :activitys="activitys"></adver>
    <!-- <top :adv="adv">
      <div slot="tips">
        <li>GLOBE/TM 查话费发送1到222,查流量发送DATABAL到8080,或*143#拨号</li>
        <li>SMART/TNT/SUN 查话费流量*123#拨号出去，选择BAL</li>
        <li>DITO查话费流量，发送HELP到185 </li>
        <li>批量充值、订单问题、套餐咨询可联系人工客服</li>
      </div>
      <myswiper :swipers="swipers"></myswiper>
      <div slot="multiRecharge">
        <div class="arrow" @click="linkTo">
          批量充值
        </div>
      </div>
    </top> -->

    <!-- <div class="wrap_container">
      <el-container>
        <el-header>
          <div class="mar-30">
            <inputArea @func="getMsg(arguments)"></inputArea>
          </div>
        </el-header>

        <el-main>
          <tabs :coupons="coupons" ref="tabs" :globe="globe" :smart="smart" :sun="sun" :theType="theType" :tm="tm" :dito="dito" :payments="payments" @checkLogin="getLogin"></tabs>
        </el-main>
      </el-container>
    </div> -->

    <!-- 改版新添加代码 s -->
    <HomeTop :advs="advs" />

    <div class="wrap_container flex-column">
      <inputArea @func="getMsg(arguments)"></inputArea>
      <tabs :coupons="coupons" ref="tabs" :globe="globe" :smart="smart" :sun="sun" :theType="theType" :tm="tm" :dito="dito" :payments="payments" :config-payments="config_payments" @checkLogin="getLogin">
      </tabs>
    </div>

    <div v-if="tab == 'first'" class="wrap_container flex-column">
      <!-- <tabs2 :coupons="coupons" ref="tabs2" :tm="tm" :theType="theType" :payments="payments" @checkLogin="getLogin"></tabs2> -->
    </div>
    <!-- 改版新添加代码 e -->

    <!-- <el-container v-if="tab == 'first'">
      <div class="wrap_container mar-t-20 wrap_child">
        <el-main style="padding: 0 10px 4px;">
          <div class="">
            <tabs2 :coupons="coupons" ref="tabs2" :tm="tm" :theType="theType" :payments="payments" @checkLogin="getLogin"></tabs2>
          </div>
        </el-main>
      </div>
    </el-container> -->

    <el-main style="position: relative;padding: 0 10px;margin-top: 25px;">
      <el-button class="historycard" type="success" @click="share">分享</el-button>
      <notice></notice>
    </el-main>

    <el-footer>Developed by 龍科技</el-footer>
    <navBar :idx="0"></navBar>
    <fullguide :fullguidetype="fullguidetype" @funa="getType"></fullguide>

  </div>
</template>

<script>
  // 导入组件
  // 样式改版新添加代码 start
  import HomeTop from '@/page/components/home/top.vue'
  // 样式改版新添加代码 end
  import tabs from '@/components/tabs'; //其他套餐
  import inputArea from '@/components/inputArea.vue';
  import grid from '@/components/grid.vue';
  import navBar from '@/components/navBar';
  import notice from '@/components/notice';
  import fullguide from '@/components/fullguide';
  // import myswiper from '@/components/swiper.vue';
  // import top from '@/components/top';
  import {getUrlParam} from '@/util/util';
  import config from '@/config';
  import adver from '@/components/adver';
  import { mapMutations } from 'vuex'
  var loading = "";

  export default {
    name: 'home',
    // 组件注册
    components: {
      // 新添加 s
      HomeTop,
      // 新添加 e
      adver,
      navBar,
      tabs,
      inputArea,
      grid,
      notice,
      fullguide,
      // myswiper,
      // top
    },
    data() {
      return {
        coupons: [],
        activitys: {},
        isnew: 1,
        pop: false,
        member_code: '',
        tab: 'first',
        theType: {
          id: 0,
          numbers: [],
        },
        globe: {},
        smart: {},
        sun: {},
        tm: {},
        dito: {},
        payments: [],
        config_payments: [],
        advs: { //广告图
          banner: [], //顶部轮播
          life: [], //生活缴费
          batch: [] //批量充值
        },
        swipers: [],
        adv: {
          pic: "",
          url: "",
        },
        fullguidetype: false,
      }
    },
    beforeCreate() { //组件生命周期函数
      // this.$loading({
      //   lock: true,
      //   background: "#ffffff"
      // })
    },
    computed: {
      tabChanged() {
        return this.$store.state.tab;
      }
    },
    watch: {
      tabChanged(now) {
        this.tab = now;
      },
    },
    created() {
      if (typeof this.$route.query.invite_code != 'undefined') {
        localStorage.setItem('invite_code', this.$route.query.invite_code);
      }
      this.init();
      if (this.$client == 'wxh5') {
        this.getShareInfo();
      }
    },
    methods: {
      ...mapMutations([
        // 'setCode',
        'setEncryArray',
        'setOrderTips',
        'setRechargeCategory',
        'setBalanceRules'
      ]),
      received(res) {
          this.init();
      },
      getShareInfo() {
        this.$api
          .request('System/wxConfig', {settlement: config.SETTLEMENT})
          .then(({
            data
          }) => {
          const {
            appId,
            nonceStr,
            signature,
            timestamp
          } = data
          // 微信分享授权
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出
            appId, // 必填，公众号的唯一标识，填自己的！
            timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
            nonceStr, // 必填，生成签名的随机串
            signature, // 必填，签名，见附录1
            jsApiList: [ // 需要使用的JS接口列表
              'onMenuShareTimeline',
              'onMenuShareAppMessage',
              'updateTimelineShareData',
              'updateAppMessageShareData'
            ]
          })
        })
        wx.ready(() => {
          // 分享到朋友圈
          wx.updateTimelineShareData({
            title: '菲律宾手机充值', // 分享标题
            link: 'https://h5.qqloon.com/#/?invite_code='+this.member_code,
            imgUrl: 'https://h5.qqloon.com/static/img/logo.61d4bb8.png',
            success: () => {
            }
          })
          //分享给朋友
          wx.updateAppMessageShareData({
            title: '菲龙网充充充',
            desc: '菲律宾话费流量快速充值，及时到账。',
            link: 'https://h5.qqloon.com/#/?invite_code='+this.member_code,
            imgUrl: 'https://h5.qqloon.com/static/img/logo.61d4bb8.png',
            success: () => {
            },
            cancel: () => {
            }
          });
        })
      },
      linkTo() {
        this.$router.push({
          name: 'multiRecharge',

        })
      },
      init() {
        this.$api
          .request('System/init', { position: 1, client: this.$client })
          .then(({ data }) => {
            console.log('data:', data)
            this.globe = data.globe;
            this.smart = data.smart;
            this.sun = data.sun;
            this.tm = data.tm;
            this.dito = data.dito;
            // this.swipers = data.banners;
            // this.adv = data.adv;
            // 得到广告图内容
            const advsKeys = Object.keys(data.advs)
            const advsValues = Object.values(data.advs)
            const newAdvs = {}
            advsKeys.forEach((item, index) => {
              newAdvs[`adv${item}`] = advsValues[index]
            })
            // 渲染顶部banner
            this.$set(this.advs, 'banner', newAdvs.adv1)
            // 生活缴费
            this.$set(this.advs, 'life', newAdvs.adv7)
            // 批量充值
            this.$set(this.advs, 'batch', newAdvs.adv8)

            this.member_code = data.member_code;
            this.pop = data.pop;
            this.isnew = data.is_new;
            this.activitys = data.activitys;
            this.coupons = data.coupons;
            localStorage.setItem('banners', data.banners);
            if (typeof data.payments == 'object') {
              this.payments = data.payments;
              localStorage.setItem('payments', JSON.stringify(data.payments));
            }
            if (typeof data.config_payments == 'object' && Array.isArray(data.config_payments)) {
              // 使用 Vue.set 确保响应式更新
              this.$set(this, 'config_payments', data.config_payments);
              console.log('home.vue 接收到 config_payments:', this.config_payments);
              // 强制通知子组件更新
              this.$nextTick(() => {
                console.log('home.vue $nextTick 后 config_payments:', this.config_payments);
                console.log('home.vue tabs ref:', this.$refs.tabs);
                if (this.$refs.tabs) {
                  console.log('home.vue tabs.configPayments:', this.$refs.tabs.configPayments);
                }
              });
            } else {
              console.warn('home.vue 未收到有效的 config_payments:', data.config_payments);
            }

            if (data.site_name) {
              document.getElementsByTagName("title")[0].innerText = data.site_name;
              localStorage.setItem('site_name', data.site_name);
            }
            if (data.site_rules) {
              localStorage.setItem('site_rules', JSON.stringify(data.site_rules));
            }
            if (data.withdraw_rules) {
              localStorage.setItem('withdrawRules', JSON.stringify(data.withdraw_rules));
            }
            if (data.order_tips) {
              localStorage.setItem('orderTips', data.order_tips);
            }
            // 加密货币列表
            this.setEncryArray(data.virtual_currencys)
            this.setOrderTips(data.order_tips)
            // 生活缴费菜单列表
            this.setRechargeCategory(data.recharge_category)

            // 订单类型(order_type)
            const orderType = data.order_type
            const orderTypeValues = Object.values(orderType)
            const newOrderType = Object.keys(orderType).map((item, index) => {
            	return {
            		id: String(item),
            		title: orderTypeValues[index]
            	}
            })
            // console.log('newOrderType:', newOrderType)
            localStorage.setItem('orderType', JSON.stringify(newOrderType));
            // 钱包余额充值选择列表
            this.setBalanceRules(data.balance_rules);

            this.getLogin();
          })
          .catch(error => {
            this.$message({
              message: error+"加载数据失败，请检查网络！",
              type: "warning"
            })
            setTimeout(() => {
              this.init();
            }, 5000)
          });
      },
      getLogin() {
        let auth_token = localStorage.getItem('auth_token');
        if (!auth_token) {
          let code = this.$route.query.code || getUrlParam('code');
          switch (this.$client) {
            case 'wxh5':
              if (code) {
                this.$api
                  .request('Wx/grantLogin', {code: code, settlement: config.SETTLEMENT})
                  .then(({
                    data
                  }) => {
                    this.$message({
                      message: "登录成功！",
                      type: "success"
                    })
                    this.isnew = data.is_new;
                    this.pop = data.pop;
                  })
                  .catch(error => {
                    this.$message({
                      message: "登录失败！",
                      type: "warning"
                    })
                    this.$router.push('/');
                  });
              } else {
                window.location.href = config.api_url + 'Wx/grant?settlement=' + config.SETTLEMENT;
              }
              break;
            case 'magapp':
              if (code) {
                this.$api
                  .request('System/grantLogin', {
                    code: code
                  })
                  .then(({
                    data
                  }) => {
                    this.$message({
                      message: "登录成功！",
                      type: "success"
                    })
                  })
                  .catch(error => {
                    this.$message({
                      message: "登录失败！",
                      type: "warning"
                    })
                    this.$router.push('/');
                  });
              } else {
                window.location.href = config.login_url;
              }
              break;
            case 'h5':
              this.$confirm(' ', '请选择', {
                distinguishCancelAndClose: true,
                confirmButtonText: '登录充值',
                cancelButtonText: '游客充值'
              }).then((action) => {
                this.$router.push('/login');
              }).catch(() => {});
              break;
            default:
              this.$message({
                message: "非法客户端！",
                type: "warning"
              })
              break;
          }
        }
      },
      getType(data) {
        if (!data) {
          this.fullguidetype = data
        }
      },
      share() {
        this.fullguidetype = true;
      },
      getMsg() {
        this.theType = {
          id: arguments[0][1],
          number: arguments[0][0],
          value: arguments[0][2],
          numbers: [],
        }
      }
    },
  }
</script>
<style lang="less">
  .el-tabs-child.el-tabs .el-tabs__header{
    width: 100%;
  }
  .home-page {
    min-height: 100vh;
    background: #EEEEEE !important;
  }
</style>
<style scoped>

  .el-container {
    /* background-color: #FFFFFF; */
    background-color: #EEEEEE;
    z-index: 2;
    box-sizing: border-box;
  }

  .wrap_container {
    position: relative;
    /* top: -80px; */
    /* background-color: #ffffff; */
    /* margin-left: 13px;
    margin-right: 13px; */
    border-radius: 9px;
    /* box-shadow: 0 0 5px #b22830; */
    border-radius: 9px;
    overflow: hidden;
    /* margin-top: 20px; */
    margin: 17px 5px 0 5px;
    background-color: #EEEEEE;
  }

  .wrap_tm {
    /*	width: 100%;
    padding: 20px 20px 0 20px;
            box-shadow: 0 0 5px #b22830;
            box-sizing: border-box;
               background-color: #FFFFFF;
                border-radius: 9px;*/




  }

  .wrap_child {
    margin: 0 13px;
    width: 100%;

  }

  .el-main {

    /* box-shadow: 5px 0px 5px -5px #b22830, -5px 0px 5px -5px #b22830; */
    /* box-shadow: 0 5px 5px #b22830; */
    /*    margin-left: 13px;
    margin-right: 13px;
    background-color: #FFFFFF;
    z-index: 2;
    border-radius: 9px;
    box-shadow: 0 5px 5px #b22830; */
  }

  .el-header {
    padding-top: 15px;
    background-color: #FFFFFF;
    z-index: 2;
    border-radius: 9px;


  }

  .mar-30 {
    margin-left: 30px;
    margin-right: 30px;
  }

  .pic_area {
    height: 2.5rem;
    line-height: 2.5rem;
    box-sizing: border-box;
    /*  margin-left: 100px;
    margin-right: 100px; */
    /* border-radius:20px; */
    /* border: 1px solid var(--theme-color); */
    display: flex;

  }

  header div {
    width: 100%;
  }

  .el-radio__input {
    display: none !important;
  }

  .el-header {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .el-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    height: 62px !important;
  }

  .el-button {}

  .historycard {
    width: 50%;
    z-index: 999;
  }

  .mar-t-20 {
    margin-top: 20px;
  }

  /* .top {
    background: url(../../static/images/round.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: auto;
    width: 100%;
    border-radius: 10px;
    overflow: hidden;
    padding-bottom: 100px;

  } */
</style>



// WEBPACK FOOTER //
// src/page/home.vue